import { useId } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import IconPhoneUpload from '@/icons/PhoneUpload.svg';

type QrCodeUploadProps = {
  size?: 'medium' | 'small';
  isDisabled?: boolean;
  onUploadFromPhone?: () => void;
  iconOnly?: boolean;
};

const QrCodeUpload = ({ isDisabled, onUploadFromPhone, iconOnly, size }: QrCodeUploadProps) => {
  const qrCodeUploadButtonId = useId();

  return (
    <label htmlFor={qrCodeUploadButtonId}>
      <Button
        id={qrCodeUploadButtonId}
        variant="secondary"
        iconOnly={iconOnly}
        size={
          iconOnly ? (size === 'small' ? 'medium' : 'large') : size === 'small' ? 'small' : 'medium'
        }
        onPress={onUploadFromPhone}
        disabled={isDisabled}
        ariaLabel={
          iconOnly
            ? t({ id: 'design-system.qr-code.button-label', message: 'Upload from a phone' })
            : undefined
        }
        tooltip={
          iconOnly
            ? t({ id: 'design-system.qr-code.button-label', message: 'Upload from a phone' })
            : undefined
        }
      >
        <IconPhoneUpload />
        {!iconOnly ? (
          <Trans id="design-system.qr-code.button-label">Upload from a phone</Trans>
        ) : null}
      </Button>
    </label>
  );
};

export default QrCodeUpload;
